import Vue from 'vue';
import messageSuccess from './messageSuccess.vue';
import messageError from './messageError';
import messageConfirm from './messageConfirm';
import networkConfirm from './networkConfirm';
var MessageSuccessConstructor = Vue.extend(messageSuccess);
var MessageErrorConstructor = Vue.extend(messageError);
var MessageConfirmConstructor = Vue.extend(messageConfirm);
var NetworkConfirmConstructor = Vue.extend(networkConfirm);

var seed = 1;
var instances = [];

var MessageBox = {};
MessageBox.Success = function (options) {
  options = options || {};
  var userOnClose = options.onClose;
  var id = 'message_success' + seed++;

  options.onClose = function() {
    if(typeof userOnClose == 'function'){
      userOnClose();
    }
    MessageBox.close(id);
  };

  var instance = new MessageSuccessConstructor({
    data:options
  });

  instance.id = id;
  instance.message = options.message;
  instance.$mount();
  if(document.getElementById("poper-smartnlp-FrameBlock")!=null){
    document.getElementById("poper-smartnlp-FrameBlock").appendChild(instance.$el);
  }else{
    document.body.appendChild(instance.$el);
  }
  instance.visible = true;
  instance.dom = instance.$el;
  instances.push(instance);
  return instance;
};

MessageBox.Error = function (options) {
  options = options || {};
  var userOnClose = options.onClose;
  var id = 'message_success' + seed++;

  options.onClose = function() {
    if(typeof userOnClose == 'function'){
      userOnClose();
    }
    MessageBox.close(id);
  };

  var instance = new MessageErrorConstructor({
    data:options
  });

  instance.id = id;
  instance.message = options.message;
  instance.$mount();
  if(document.getElementById("poper-smartnlp-FrameBlock")!=null){
    document.getElementById("poper-smartnlp-FrameBlock").appendChild(instance.$el);
  }else{
    document.body.appendChild(instance.$el);
  }
  instance.visible = true;
  instance.dom = instance.$el;
  instances.push(instance);
  return instance;
};

MessageBox.Confirm = function (options) {
  options = options || {};
  var userOnClose = options.onClose;// 关闭按钮回调
  var userOnCancel = options.onCancel;// 取消按钮回调
  var userOnConfirm = options.onConfirm;// 确认按钮回调
  var id = 'message_success' + seed++;

  options.onClose = function() {
    if(typeof userOnClose == 'function'){
      userOnClose();
    }
    MessageBox.close(id);
  };
  options.onCancel = function () {
    if(typeof userOnCancel == 'function'){
      userOnCancel();
    }
    MessageBox.close(id);
  };
  options.onConfirm = function () {
    if(typeof userOnConfirm == 'function'){
      userOnConfirm();
    }
    MessageBox.close(id);
  };

  var instance = new MessageConfirmConstructor({
    data:options
  });

  instance.id = id;
  instance.$mount();
  document.getElementById("poper-smartnlp-FrameBlock").appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instances.push(instance);
  return instance;
};

MessageBox.NetworkConfirm = function (options) {
  options = options || {};
  var userOnClose = options.onClose;// 关闭按钮回调
  var userOnCancel = options.onCancel;// 取消按钮回调
  var userOnConfirm = options.onConfirm;// 确认按钮回调
  var id = 'message_success' + seed++;

  options.onClose = function() {
    if(typeof userOnClose == 'function'){
      userOnClose();
    }
    MessageBox.close(id);
  };
  options.onCancel = function () {
    if(typeof userOnCancel == 'function'){
      userOnCancel();
    }
    MessageBox.close(id);
  };
  options.onConfirm = function () {
    if(typeof userOnConfirm == 'function'){
      userOnConfirm();
    }
    MessageBox.close(id);
  };

  var instance = new NetworkConfirmConstructor({
    data:options
  });

  instance.id = id;
  instance.$mount();
  // document.body.appendChild(instance.$el);
  document.getElementById("poper-smartnlp-FrameBlock").appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instances.push(instance);
  return instance;
};

MessageBox.close = function (id) {
  if(!id){
    return;
  }
  for(var i = 0; instances && i < instances.length; i++){
    if(instances[i].id == id){
      instances.splice(i, 1);
    }
  }
};
export default MessageBox;
